<template>
  <div class="row">
    <div class="col-md-12">
      <div id="chartdivNsepContact"></div>
    </div>
    <div class="col-md-12">
      <div id="chartdivContactsPerORW"></div>
    </div>
    <div class="col-md-12">
      <div id="chartdivSyringeDistributed"></div>
    </div>
  </div>
</template>

<script>
// importing AMCharts
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
//default theme for AMcharts
am4core.useTheme(am4themes_animated);

export default {
  name: "bubble-chart",
  data() {
    return {
      data: null,
    };
  },
  methods: {
    callBubbleChart() {
      axios
        .get("cityWiseBubbleChart")
        .then((response) => {
          this.data = response.data;
          this.popuplateBubbleChart(this.data);
            this.popuplateNsepContact(this.data);
            this.popuplateContactsPerORW(this.data);
            this.popuplateSyringeDistributed(this.data);
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    popuplateNsepContact(data) {
      am4core.ready(function () {
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = am4core.create("chartdivNsepContact", am4charts.XYChart);

        chart.data = data;
        chart.zoomOutButton.align = "left";
        chart.zoomOutButton.valign = "bottom";
        chart.zoomOutButton.parent = chart.tooltipContainer;
        chart.padding(40, 40, 40, 40);

        // Title
        let title = chart.titles.create();
        title.text = "NSEP Contact City Wise";
        title.fontSize = 18;
        title.marginBottom = 30;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "CityShortName";
        categoryAxis.renderer.minGridDistance = 60;
        categoryAxis.renderer.inversed = false;
        categoryAxis.renderer.grid.template.disabled = true;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        //valueAxis.rangeChangeEasing = am4core.ease.linear;
        //valueAxis.rangeChangeDuration = 1500;

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "CityShortName";
        series.dataFields.valueY = "NSEPContact";
        series.tooltipText = "{valueY.value}";
        series.columns.template.strokeOpacity = 0;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.cornerRadiusTopLeft = 10;
        //series.interpolationDuration = 1500;
        //series.interpolationEasing = am4core.ease.linear;
        var labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.verticalCenter = "bottom";
        labelBullet.label.dy = -20;
        labelBullet.label.dx = 10;
        labelBullet.label.truncate = false;
        labelBullet.label.rotation = 270;
        labelBullet.label.text =
          "{values.valueY.workingValue.formatNumber('#.')}";

        chart.zoomOutButton.disabled = true;

        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.dx = -20;
        categoryAxis.renderer.minGridDistance = 1;
        // categoryAxis.sortBySeries = series;
      }); // end am4core.ready()
    },
    popuplateContactsPerORW(data) {
      am4core.ready(function () {
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = am4core.create("chartdivContactsPerORW", am4charts.XYChart);

        chart.data = data;
        chart.zoomOutButton.align = "left";
        chart.zoomOutButton.valign = "bottom";
        chart.zoomOutButton.parent = chart.tooltipContainer;
        chart.padding(40, 40, 40, 40);

        // Title
        let title = chart.titles.create();
        title.text = "NSEP Contacts Per ORW City Wise";
        title.fontSize = 18;
        title.marginBottom = 30;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "CityShortName";
        categoryAxis.renderer.minGridDistance = 60;
        categoryAxis.renderer.inversed = false;
        categoryAxis.renderer.grid.template.disabled = true;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        //valueAxis.rangeChangeEasing = am4core.ease.linear;
        //valueAxis.rangeChangeDuration = 1500;

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "CityShortName";
        series.dataFields.valueY = "ContactPerORWs";
        series.tooltipText = "{valueY.value}";
        series.columns.template.strokeOpacity = 0;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.cornerRadiusTopLeft = 10;
        //series.interpolationDuration = 1500;
        //series.interpolationEasing = am4core.ease.linear;
        var labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.verticalCenter = "bottom";
        labelBullet.label.dy = -20;
        labelBullet.label.dx = 10;
        labelBullet.label.truncate = false;
        labelBullet.label.rotation = 270;
        labelBullet.label.text =
          "{values.valueY.workingValue.formatNumber('#.')}";

        chart.zoomOutButton.disabled = true;

        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.dx = -20;
        categoryAxis.renderer.minGridDistance = 1;
        // categoryAxis.sortBySeries = series;
      }); // end am4core.ready()
    },
    popuplateSyringeDistributed(data) {
      am4core.ready(function () {
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = am4core.create(
          "chartdivSyringeDistributed",
          am4charts.XYChart
        );

        chart.data = data;
        chart.zoomOutButton.align = "left";
        chart.zoomOutButton.valign = "bottom";
        chart.zoomOutButton.parent = chart.tooltipContainer;
        chart.padding(40, 40, 40, 40);

        // Title
        let title = chart.titles.create();
        title.text = "Syringe Distributed City Wise";
        title.fontSize = 18;
        title.marginBottom = 30;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "CityShortName";
        categoryAxis.renderer.minGridDistance = 60;
        categoryAxis.renderer.inversed = false;
        categoryAxis.renderer.grid.template.disabled = true;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        //valueAxis.rangeChangeEasing = am4core.ease.linear;
        //valueAxis.rangeChangeDuration = 1500;

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "CityShortName";
        series.dataFields.valueY = "SyringeDistributed";
        series.tooltipText = "{valueY.value}";
        series.columns.template.strokeOpacity = 0;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.cornerRadiusTopLeft = 10;
        //series.interpolationDuration = 1500;
        //series.interpolationEasing = am4core.ease.linear;
        var labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.verticalCenter = "bottom";
        labelBullet.label.dy = -20;
        labelBullet.label.dx = 10;
        labelBullet.label.truncate = false;
        labelBullet.label.rotation = 270;
        labelBullet.label.text =
          "{values.valueY.workingValue.formatNumber('#.')}";

        chart.zoomOutButton.disabled = true;

        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.dx = -20;
        categoryAxis.renderer.minGridDistance = 1;
        // categoryAxis.sortBySeries = series;
      }); // end am4core.ready()
    },
  },
  mounted() {
    this.callBubbleChart();
  },
};
</script>

<style lang="scss" scoped>
#chartdivNsepContact {
  width: 100%;
  height: 500px;
}
#chartdivContactsPerORW {
  width: 100%;
  height: 500px;
}
#chartdivSyringeDistributed {
  width: 100%;
  height: 500px;
}
</style>